import 'pusher-js';
import axios from 'axios';
import Echo from 'laravel-echo';
import { createApp } from 'vue';

import { store } from './store';
import {
    REMOVE_USER_ROOMMATE,
    REMOVE_USER_ROOM,
    SELECT_ROOM,
    SET_ROOM,
    SET_USER_ROOM,
} from './store/constants/mutations';

const echo = new Echo({
    broadcaster: 'pusher',
    key: PUSHER_CONFIG.key,
    wsHost: PUSHER_CONFIG.host,
    wsPort: 80,
    wssPort: 443,
    forceTLS: false,
    encrypted: true,
    disableStats: true,
    enabledTransports: ['ws', 'wss'],
});

const app = createApp({
    data() {
        return {
            isLoading: false,
        };
    },
    beforeCreate() {
        axios.interceptors.request.use(
            (req) => {
                req.headers.Accept = 'application/json';
                this.isLoading = true;
                return req;
            },
            (err) => {
                this.isLoading = false;
                return Promise.reject(err);
            }
        );

        axios.interceptors.response.use(
            (resp) => {
                this.isLoading = false;
                return resp;
            },
            (err) => {
                this.isLoading = false;
                return Promise.reject(err);
            }
        );

        store
            .dispatch('User/login')
            .then((user) => {
                if (user) {
                    echo.private('everyone').listen(
                        'RoomStateChangeEvent',
                        ({ room_number: roomNumber, count }) => {
                            store.commit(`Room/${SET_ROOM}`, { roomNumber, count });
                            if (roomNumber === store.state.Popup.activeRoom) {
                                store.dispatch('Popup/getRoomInfo', roomNumber);
                            }
                            if (roomNumber === store.state.User.user?.room_number) {
                                store.dispatch('User/getUserInfo', {root: true});
                            }
                        }
                    );

                    echo.private(`personal.${user.neptun}`)
                        .listen(
                            'InvitationEvent',
                            ({
                                roommate,
                                room_number: roomNumber,
                                reservation_id: reservationId,
                            }) => {
                                // console.log('INVITED', { reservationId, roommate, roomNumber });
                                store.commit(
                                    `User/${SET_USER_ROOM}`,
                                    {
                                        room: roomNumber,
                                        roommate,
                                        status: 'INVITED',
                                        by: roommate,
                                        reservationId,
                                    },
                                    { root: true }
                                );
                                store.dispatch(`Popup/selectRoom`, roomNumber);
                            }
                        )
                        .listen('ApplicationEvent', ({ roommate, room_number: roomNumber, reservation_id }) => {
                            // console.log('APPLIED', { roommate, roomNumber });
                            store.commit(
                                `User/${SET_USER_ROOM}`,
                                {
                                    room: roomNumber,
                                    roommate,
                                    roommateStatus: 'APPLIED',
                                    roommateReservationId: reservation_id
                                },
                                { root: true }
                            );
                            store.commit(`Popup/${SELECT_ROOM}`, roomNumber);
                        })
                        .listen('AcceptEvent', ({ roommate, room_number: roomNumber }) => {
                            // console.log('ACCEPTED', { roommate, roomNumber });
                            store.commit(
                                `User/${SET_USER_ROOM}`,
                                {
                                    room: roomNumber,
                                    roommate,
                                    status: 'RESERVED', // TODO: ASSIGNED?
                                    roommateStatus: 'RESERVED',
                                },
                                { root: true }
                            );
                        })
                        .listen('DeclineEvent', ({ roommate, room_number: roomNumber }) => {
                            // console.log('DECLINED', { roommate, roomNumber });
                            store.commit(`User/${REMOVE_USER_ROOMMATE}`, {}, { root: true });
                        })
                        .listen('CancelEvent', ({ roommate, room_number: roomNumber }) => {
                            // console.log('CANCELLED', { roommate, roomNumber });
                            store.commit(`User/${REMOVE_USER_ROOMMATE}`, {}, { root: true });
                        });
                }
            })
            .catch(console.log);
    },
});

const files = require.context('./', true, /\.vue$/i);
files.keys().map((key) => app.component(key.split('/').pop().split('.')[0], files(key).default));

app.use(store);
app.mount('#app');
